module.exports = __webpack_public_path__ + "img/no-search-found.24956e58.png";